export default __webpack_public_path__ + "static/media/Basayya_Hiremath.ea43824a.JPG";